import PropTypes from 'prop-types';
import React from 'react';
import {DisplayMode} from './controls_helper';
import {ToggleButton} from '@social-native/snclient-ui';
import '@social-native/snclient-ui/dist/style.css';

const ViewSelector = ({currentDisplayMode, changeViewMode}) => {
    const isListMode = currentDisplayMode === DisplayMode.LIST;

    return (
        <div className="view-toggle-container">
            <ToggleButton
                name="view-mode"
                id="list-mode"
                value={DisplayMode.LIST}
                checked={isListMode}
                onChange={e => changeViewMode(e.target.value)}
                title="List View"
                iconName="bars"
                size="xs"
                color="gray"
                behavior="radio"
            >
            </ToggleButton>
            <ToggleButton
                name="view-mode"
                id="grid-mode"
                value={DisplayMode.GRID}
                checked={!isListMode}
                onChange={e => changeViewMode(e.target.value)}
                title="Grid View"
                iconName="border-all"
                size="xs"
                color="gray"
                behavior="radio"
            >
            </ToggleButton>
        </div>
    );
};

ViewSelector.propTypes = {
    changeViewMode: PropTypes.func.isRequired,
    currentDisplayMode: PropTypes.string.isRequired
};

export default ViewSelector;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/posts_controls_row/view_selector.js